export interface IQuery { }

export class AllProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Portfolios.Queries.AllProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number

	constructor (workspaceId: number, tchProjectId: number)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Portfolios.Queries.AllProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

export class FinishedProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Portfolios.Queries.FinishedProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number

	constructor (workspaceId: number, tchProjectId: number)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Portfolios.Queries.FinishedProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

export class LinkeableTchProjectsByWorkspaceIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Portfolios.Queries.LinkeableTchProjectsByWorkspaceIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number

	constructor (workspaceId: number)
	{
		this.WorkspaceId = workspaceId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Portfolios.Queries.LinkeableTchProjectsByWorkspaceIdQueryV1, TCh.Domain.Quest'
	}

}

export class PnlPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Portfolios.Queries.PnlPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	ViewDefId: string
	PnlId: string | null
	ApplyBenefitsConfidenceFactor: boolean
	Denomination: any

	constructor (workspaceId: number, tchProjectId: number, viewDefId: string, pnlId: string | null, applyBenefitsConfidenceFactor: boolean, denomination: any)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.ViewDefId = viewDefId
		this.PnlId = pnlId
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
		this.Denomination = denomination
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Portfolios.Queries.PnlPageQueryV1, TCh.Domain.Quest'
	}

}

export class PortfolioPlanningModuleStatusQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Portfolios.Queries.PortfolioPlanningModuleStatusQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number

	constructor (workspaceId: number, tchProjectId: number)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Portfolios.Queries.PortfolioPlanningModuleStatusQueryV1, TCh.Domain.Quest'
	}

}

export class PortfolioSettingsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Portfolios.Queries.PortfolioSettingsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number

	constructor (workspaceId: number, tchProjectId: number)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Portfolios.Queries.PortfolioSettingsQueryV1, TCh.Domain.Quest'
	}

}

export class PortfoliosPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Portfolios.Queries.PortfoliosPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Portfolios.Queries.PortfoliosPageQueryV1, TCh.Domain.Quest'
	}

}

export class ProposedProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Portfolios.Queries.ProposedProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number

	constructor (workspaceId: number, tchProjectId: number)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Portfolios.Queries.ProposedProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

export class ScheduledProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Portfolios.Queries.ScheduledProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number

	constructor (workspaceId: number, tchProjectId: number)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Portfolios.Queries.ScheduledProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

export class SpreadsheetImportMappingQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Portfolios.Queries.SpreadsheetImportMappingQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number
	BlobId: string

	constructor (workspaceId: number, tchProjectId: number, blobId: string)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
		this.BlobId = blobId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Portfolios.Queries.SpreadsheetImportMappingQueryV1, TCh.Domain.Quest'
	}

}

export class StartedProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Portfolios.Queries.StartedProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number

	constructor (workspaceId: number, tchProjectId: number)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Portfolios.Queries.StartedProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

